import { Link } from 'react-router';
import { countInlineMath, MathText } from '../dvi/MathText';
import type { Article } from '../types/articles';
import { dateLabel } from '../lib/wareki';

export function ArticleCard({ article }: { article: Article }) {
  // DVI 記事・断片記事はサイト内の記事ページでインライン閲覧できる
  const hasArticlePage =
    article.fragments !== null || (article.link !== null && /\.dvi$/i.test(article.link.url));
  const metaUrl = `/articles/${article.slug}/meta.formulas.dvi`;
  const title = <MathText text={article.title} formulasUrl={metaUrl} pages={article.metaPages} />;
  return (
    <article className="article-card">
      <h3>
        {hasArticlePage ? <Link to={`/${article.section}/${article.slug}`}>{title}</Link> : title}
      </h3>
      <p>
        <MathText
          text={article.abstract}
          formulasUrl={metaUrl}
          pages={article.metaPages}
          pageOffset={countInlineMath(article.title)}
        />
      </p>
      <dl>
        <div>
          <dt>リンク</dt>
          <dd>
            {article.link ? (
              <a
                href={article.link.url}
                target="_blank"
                rel="noreferrer"
                download={article.link.label === 'DVI' || undefined}
              >
                {article.link.label}
              </a>
            ) : article.fragments ? (
              'サイト内記事'
            ) : (
              '準備中'
            )}
          </dd>
        </div>
        <div>
          <dt>公開日</dt>
          <dd>{dateLabel(article.status, article.published)}</dd>
        </div>
        <div>
          <dt>更新日</dt>
          <dd>{dateLabel(article.status, article.updated)}</dd>
        </div>
      </dl>
    </article>
  );
}
